export const articles = [
  {
    id: "a01",
    title: "顶流男演员被指签订阴阳合同，补缴与罚款金额成焦点",
    cat: "tax",
    tag: "税务爆料",
    excerpt:
      "据多名业内人士透露，某一线顶流男演员近年连续两部头部剧集被指存在“报低价、收高价”的阴阳合同，相关税务部门已介入核查。",
    body: [
      "知情人士称，涉事男演员的两部热播剧均以低于市场行情的“打包价”对外报备，而演员实际收款则被拆分至多个关联工作室，疑似为规避较高档次的个税与增值税。两份报备文件与真实收款流水存在明显出入，差额或达数千万元。",
      "截至发稿，税务稽查部门已要求涉事工作室限期提供完整财务账册，补缴与滞纳金数额尚在核算中。其经纪公司回应称“正在全力配合自查，一切以官方通报为准”，但品牌方已有多家开始观望后续代言续约安排。",
    ],
    date: "09-09",
    time: "14:20",
    source: "独家追踪",
    reads: "186.4万",
    heat: 99,
    image:
      "https://readdy.ai/api/search-image?query=stack%20of%20business%20tax%20receipts%20and%20financial%20documents%20on%20a%20warm%20oak%20desk%20under%20soft%20window%20light%2C%20editorial%20documentary%20style%2C%20muted%20warm%20film%20tones%20with%20subtle%20crimson%20accent%2C%20crisp%20paper%20textures%2C%20shallow%20depth%20of%20field%2C%20clean%20organized%20composition%2C%20high%20detail&width=800&height=600&seq=tax-docs-01&orientation=landscape",
    featured: true,
  },
  {
    id: "a02",
    title: "爆款综艺被曝招商报价注水，植入实际成交价腰斩",
    cat: "rule",
    tag: "行业潜规则",
    excerpt:
      "多位广告投放从业者爆料：部分头部综艺对外公布的“单季冠名费”动辄数亿，但真实成交价往往不足对外报价的一半，水分集中在中介抽成与流量保底。",
    body: [
      "一名长期操盘综艺投放的媒介代理透露，对外招商册上的“参考刊例价”普遍被刻意抬高，目的是给品牌方留出“砍价空间”。实际成交通常以刊例价的三到五折敲定，差额的一部分会回流为代理返点。",
      "更普遍的做法是“流量保底承诺”：节目方与品牌约定某条线上话题或播放量门槛，未达标时以补量、加播或延长曝光等方式“找平”。多位从业者坦言，这种保底在账面上常常难以完全兑现，最终多以资源置换了结。",
    ],
    date: "09-09",
    time: "11:05",
    source: "行业调查",
    reads: "96.8万",
    heat: 88,
    image:
      "https://readdy.ai/api/search-image?query=backstage%20of%20a%20television%20studio%20with%20lighting%20rigs%20and%20camera%20equipment%20in%20warm%20haze%2C%20cinematic%20editorial%20documentary%2C%20muted%20amber%20and%20crimson%20tones%2C%20industrial%20mood%2C%20layered%20composition%2C%20atmospheric%20depth&width=800&height=600&seq=studio-backstage-01&orientation=landscape",
    featured: true,
  },
  {
    id: "a03",
    title: "新生代爱豆被曝私德争议，多个品牌连夜撤下宣传物料",
    cat: "kua",
    tag: "塌房预警",
    excerpt:
      "某刚斩获年度新人奖的偶像组合成员陷入私德争议，其所属平台已被拍到连夜撤换多块电子屏广告，团队暂未作正式回应。",
    body: [
      "争议源于一组据称是该成员与粉丝私下往来的聊天截图在多个小组内流传，内容涉及暧昧称呼与疑似违规的粉丝应援收款。截图真伪尚未经技术验证，但在粉丝圈内传播迅速，已引发大量脱粉与超话换头像运动。",
      "风险信号最先出现在商业端：截至发稿，至少两家美妆与一家快消品牌已调整其宣传排期，撤下该成员的代言画面，改为“物料更新中”。娱乐法律师指出，若争议升级为事实性负面，品牌方通常保留“道德条款”解约权利。",
    ],
    date: "09-08",
    time: "21:40",
    source: "粉丝圈跟进",
    reads: "203.1万",
    heat: 96,
    image:
      "https://readdy.ai/api/search-image?query=dark%20empty%20concert%20stage%20with%20dim%20red%20stage%20lights%20and%20a%20single%20microphone%20stand%2C%20moody%20atmospheric%20editorial%20shot%2C%20crimson%20and%20amber%20glow%2C%20cinematic%20vignette%2C%20dust%20in%20light%20beams%2C%20dramatic%20composition&width=800&height=600&seq=stage-dim-01&orientation=landscape",
    featured: true,
  },
  {
    id: "a04",
    title: "头部主播被指少缴税款，直播团队连夜修改佣金口径",
    cat: "tax",
    tag: "税务爆料",
    excerpt:
      "顶流带货主播所在机构被指通过“坑位费+高佣”拆分规避个税，其团队次日便更新了对外报价单的佣金表述，被网友指为“紧急找补”。",
    body: [
      "爆料称，该主播的部分商品合作采用“低价坑位费+远超平均的高额佣金”组合，佣金收入被导向以灵活用工名义代发，从而适用更低的核定比例。税务系统数据比对新规落地后，这类操作被纳入重点筛查。",
      "团队方面则回应，报价单更新属例行调整，“不存在偷逃税款，所有收入均已依法申报”。多位财税人士表示，佣金与坑位费拆分是否合规，关键在于真实业务实质与资金流向能否自洽。",
    ],
    date: "09-08",
    time: "17:12",
    source: "直播观察",
    reads: "154.6万",
    heat: 91,
    image:
      "https://readdy.ai/api/search-image?query=minimal%20livestreaming%20setup%20with%20ring%20light%2C%20smartphone%20and%20product%20box%20on%20a%20clean%20desk%2C%20warm%20neutral%20tones%20with%20soft%20red%20accent%2C%20editorial%20photography%2C%20tidy%20composition%2C%20soft%20shadows&width=800&height=600&seq=livestream-setup-01&orientation=landscape",
  },
  {
    id: "a05",
    title: "一线女星深陷天价解约官司，片约去留成行业关注点",
    cat: "contract",
    tag: "合同纠纷",
    excerpt:
      "一线女演员与原经纪公司就“天价违约金”展开对簿公堂，双方对合约中业绩对赌条款的理解分歧巨大，多部待播剧去向待定。",
    body: [
      "纠纷核心是一份签署于四年前的经纪长约中的“业绩承诺”条款：原公司认为女星未达约定商单与曝光指标，有权主张高额违约金；女星方则指该条款系公司单方设定、实施中存在不透明分摊，主张其已超额履行。",
      "法院首次庭前会议后，双方均暂未接受调解。业内关注点集中在：若女星被认定违约，其已签约的剧组与品牌将面临连环解约与索赔风险，或将牵动多部待播作品的档期重排。",
    ],
    date: "09-08",
    time: "10:33",
    source: "法庭旁听",
    reads: "142.9万",
    heat: 90,
    image:
      "https://readdy.ai/api/search-image?query=hands%20signing%20a%20thick%20legal%20contract%20with%20a%20fountain%20pen%2C%20scattered%20contract%20pages%20on%20a%20warm%20wooden%20table%2C%20muted%20warm%20cinematic%20tones%20with%20amber%20highlights%2C%20editorial%20documentary%2C%20shallow%20depth%20of%20field%2C%20focused%20detail&width=800&height=600&seq=signing-contract-01&orientation=landscape",
  },
  {
    id: "a06",
    title: "剧集导演被指涉嫌合同诈骗，实锤材料疑现多重伪造",
    cat: "fazhi",
    tag: "法制咖锤",
    excerpt:
      "某知名剧集导演被多名合作方指控以“立项”“过审”为名收取资金却迟迟未开拍，流出的文件被指存在印章疑点，警方已受理报案。",
    body: [
      "据报案材料显示，导演方以多个剧集项目名义收取合作方保证金与投资款，声称用于前期筹备与立项报批，但项目多数停留在口头阶段。多名出资方出示的合同、立项回执与盖章文件，被专业机构初步鉴定存在“疑似伪造”痕迹。",
      "目前相关属地公安机关已就合同诈骗嫌疑正式受理报案并开展初查，导演经纪团队回应“正在配合说明情况”。法律人士提醒，影视投资务必核实项目备案信息与付款账户一致性，避免被“立项话术”误导。",
    ],
    date: "09-07",
    time: "19:02",
    source: "立案跟进",
    reads: "118.7万",
    heat: 87,
    image:
      "https://readdy.ai/api/search-image?query=wooden%20judge%20gavel%20on%20a%20warm%20wooden%20table%20beside%20document%20papers%2C%20muted%20editorial%20investigative%20photography%2C%20warm%20tones%20with%20soft%20crimson%20accents%2C%20focused%20foreground%2C%20cinematic&width=800&height=600&seq=gavel-legal-01&orientation=landscape",
  },
  {
    id: "a07",
    title: "二线演员控诉剧组“阴阳剧本”，临时改词成行业顽疾",
    cat: "rule",
    tag: "行业潜规则",
    excerpt:
      "一名二线演员公开发声，指部分剧组以“送审版”名义使用一版剧本、实际拍摄使用另一版，导致其戏份与设定严重偏离合同约定。",
    body: [
      "该演员透露，签约时片方出示的是“送审用精简版”，拍摄期间却频繁临时改词加戏，实际呈现与其试镜预期相差甚远，且改词往往压缩休息时间、挤占其同期商演档期。",
      "多位编剧与经纪人证实，“阴阳剧本”在部分快餐化项目里并不少见，核心原因是平台分账与播放热度考核倒逼“边拍边改”。但从业者普遍认为，契约精神缺位与改词成本转嫁，才是矛盾真正的导火索。",
    ],
    date: "09-07",
    time: "13:26",
    source: "从业者来信",
    reads: "87.5万",
    heat: 82,
    image:
      "https://readdy.ai/api/search-image?query=editorial%20newspaper%20front%20pages%20and%20vintage%20tabloid%20print%20on%20a%20wooden%20desk%20in%20warm%20light%2C%20vintage%20typewriter%20and%20reading%20glasses%2C%20muted%20sepia%20and%20crimson%20tones%2C%20nostalgic%20documentary%20mood&width=800&height=600&seq=newsroom-collage-01&orientation=landscape",
  },
  {
    id: "a08",
    title: "人气女团成员被指私下恋爱，公司声明含糊留悬念",
    cat: "kua",
    tag: "塌房预警",
    excerpt:
      "人气女团成员被拍到与神秘男子同框，疑似私下恋爱，公司以“不便回应私生活”回应，粉丝站反应两极。",
    body: [
      "狗仔发布的短视频显示，该成员结束演出后与一名男子同车返回公寓，并多次同乘出入。由于正值组合回归宣发期，恋爱传闻迅速冲上多平台热搜，超话内“祝福派”与“事业派”争执不休。",
      "经纪公司在晚间发出一条语焉不详的声明，仅称“相关私生活不便回应，请关注舞台作品”，既未否认也未证实，被粉丝解读为“默认”或“冷处理”。业内人士称，此类声明往往是观察事件是否继续发酵的风向标。",
    ],
    date: "09-07",
    time: "08:55",
    source: "热搜雷达",
    reads: "168.3万",
    heat: 93,
    image:
      "https://readdy.ai/api/search-image?query=silhouette%20of%20a%20large%20audience%20with%20smartphone%20flashes%20in%20a%20dim%20venue%2C%20warm%20amber%20and%20red%20concert%20lights%2C%20cinematic%20editorial%20style%2C%20energetic%20yet%20muted%2C%20soft%20bokeh%2C%20atmospheric&width=800&height=600&seq=audience-flash-01&orientation=landscape",
  },
  {
    id: "a09",
    title: "实锤证据链：某选秀断层出道位被指“刷票”,数据源争议难解",
    cat: "proof",
    tag: "实锤证据链",
    excerpt:
      "围绕某选秀节目断层出道位“是否刷票”，我们按时间线整理了三波关键证据：投票曲线、IP分布与主办方回应。",
    body: [
      "第一波：决赛夜该选手投票数呈非自然“断崖式”上涨，单小时增速为对手的十余倍；第二波：技术流网友抓取到同一批IP在短时间内集中产生大量投票记录；第三波：主办方先后以“风控系统正常”与“正在复核”两版口径回应，口径前后存在出入。",
      "截至目前，主办方尚未公布完整数据审计报告，事件仍处“疑似刷票、尚未坐实”阶段。我们把三波证据按时间线归档，供读者自行研判信息缺口所在。",
    ],
    date: "09-06",
    time: "22:18",
    source: "证据链工作室",
    reads: "221.9万",
    heat: 98,
    image:
      "https://readdy.ai/api/search-image?query=open%20case%20file%20folder%20with%20printed%20documents%20and%20a%20red%20evidence%20seal%20on%20a%20warm%20leather%20desk%2C%20editorial%20investigative%20style%2C%20muted%20warm%20tones%20with%20crimson%20accents%2C%20dramatic%20soft%20light%2C%20paper%20texture%20detail&width=800&height=600&seq=evidence-folder-01&orientation=landscape",
    featured: true,
  },
  {
    id: "a10",
    title: "影视公司年报现诡异亏损，多笔“剧本费”去向成谜",
    cat: "tax",
    tag: "税务爆料",
    excerpt:
      "一份流出的影视公司内部年报显示，多笔大额“剧本采购费”计入了成本端，但对应剧本迟迟未立项，审计追问下疑点重重。",
    body: [
      "据披露材料，该公司在三个财年内以“剧本采购”“版权储备”名义列支逾亿元成本，然而其中多数项目从未出现在开机备案名单中。疑似存在以虚构成本冲抵利润、进而影响税务基数的操作空间。",
      "会计师分析认为，此类操作若成立，将直接侵蚀企业所得税与分账收入的计税基础。该公司目前尚未对媒体质询作出公开说明，仅表示“财报以年审意见为准”。",
    ],
    date: "09-06",
    time: "15:44",
    source: "财报深扒",
    reads: "76.2万",
    heat: 79,
    image:
      "https://readdy.ai/api/search-image?query=modern%20minimal%20high%20rise%20facade%20reflecting%20warm%20sunset%20light%20with%20subtle%20red%20sky%2C%20cinematic%20architectural%20editorial%20shot%2C%20amber%20and%20crimson%20grading%2C%20clean%20lines%2C%20dramatic%20composition&width=800&height=600&seq=tower-sunset-01&orientation=landscape",
  },
];